export const regex = {
  capitalRequired: /[A-Z]/g,
  numberRequired: /[0-9]/g,
};
